import { ItemRecordFields } from "./ItemRecordFields.js";
import { PersonRecordFields } from "./PersonRecordFields.js";
import { VehicleRecordFields } from "./VehicleRecordFields.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Records/shared/RecordModal/components/InfoTab/index.tsx
var RECORD_TYPES = {
	ITEM: "item",
	PERSON: "person",
	VEHICLE: "vehicle"
};
function InfoTab({ canEdit, onFieldChange, record }) {
	if (record.type === RECORD_TYPES.ITEM) return /* @__PURE__ */ jsx(ItemRecordFields, {
		canEdit,
		onFieldChange,
		record
	});
	if (record.type === RECORD_TYPES.PERSON) return /* @__PURE__ */ jsx(PersonRecordFields, {
		canEdit,
		onFieldChange,
		record
	});
	if (record.type === RECORD_TYPES.VEHICLE) return /* @__PURE__ */ jsx(VehicleRecordFields, {
		canEdit,
		onFieldChange,
		record
	});
	return null;
}
//#endregion
export { InfoTab };

//# sourceMappingURL=index.js.map